/* eslint-disable no-shadow, func-names, prefer-arrow-callback, no-undef */
import $ from 'jquery';
import moment from 'moment';
import 'moment/locale/fr';
import 'bootstrap-daterangepicker';

moment.locale('fr');

window.YP.FilterTable = function FilterTable() {
    return {
        init() {
            const filter = $('.c-sheet');
            const filterInput = $('.c-sheet__content .c-form-input');
            const filterItemClear = $('.c-sheet__item--clear');
            const toggleFilter = $('#js-toggle-filter');
            const resetFilter = $('#js-reset-research');
            const exportFilter = $('#js-export-research');
            const toggleFilterResultContainer = $('.c-table__filter-result');
            const searchBar = $('.c-form-input__search');
            const clearSearchBar = $('.c-form-input__search--clear');
            const selectResultPerPage = $('.js-nb-per-page-select');
            const filterSectionToggles = $('.js-filter-section .c-sheet__item');

            filterInput.on('change', this.showFilterItemTag);
            filterInput.on('change', () => this.updateSectionCounts());

            filterItemClear.on('click', this.clearFilterItemTag);
            filterSectionToggles.on('click', this.toggleSection);

            // Initialize date range picker
            this.initDateRangePicker();

            // Listen to web components change events to update section counts
            const self = this;
            document.querySelectorAll('combo-box').forEach((combobox) => {
                combobox.addEventListener('change', () => {
                    self.updateSectionCounts();
                });
            });
            document.querySelectorAll('date-range-picker').forEach((picker) => {
                picker.addEventListener('change', () => {
                    self.updateSectionCounts();
                });
            });

            // Toggle filter container
            toggleFilter.on('click', (e) => {
                e.preventDefault();
                filter.toggle();
            });

            // Hide filter container
            $(document).mouseup(function (e) {
                const isInsideDateRangePicker = $(e.target).closest('.react-datepicker-popper').length > 0
                    || $(e.target).closest('[id^="date-range-picker-popper"]').length > 0;
                // Check if click is inside react-select menu (ComboBox dropdown)
                const isInsideReactSelectMenu = $(e.target).closest('[class*="menu"]').length > 0
                    || $(e.target).closest('[id^="react-select"]').length > 0
                    || $(e.target).closest('[id^="combo-box-popper"]').length > 0;
                // Check if click is inside select2 dropdown (rendered in body)
                const isInsideSelect2 = $(e.target).closest('.select2-drop').length > 0
                    || $(e.target).closest('.select2-container').length > 0;
                if (!filter.is(e.target) && filter.has(e.target).length === 0 && $(e.target).parents('.datepicker').length <= 0 && $(e.target).parents('.sp-container').length <= 0 && $(e.target).parents('.time-picker').length <= 0 && !isInsideDateRangePicker && !isInsideReactSelectMenu && !isInsideSelect2) {
                    filter.hide();
                }
                $('.yp_font_close').on('click', function (e) {
                    e.preventDefault();
                    filter.hide();
                });
                $('.js-hide-filter').on('click', function (e) {
                    e.preventDefault();
                    filter.hide();
                });
            });

            // Apply tag on filter itme on reload
            $(document).ready(() => {
                filterInput.change();
                this.updateSectionCounts();
            });

            $(document).ready(() => {
                toggleFilterResultContainer.find('.c-tag').remove();

                // Fonction pour formater une date ISO en date locale lisible
                const formatDateRange = function(isoDateRange) {
                    if (!isoDateRange || !isoDateRange.includes('|')) {
                        return isoDateRange;
                    }
                    const parts = isoDateRange.split('|');
                    if (parts.length !== 2) return isoDateRange;

                    const userLocale = navigator.language || 'fr-FR';
                    const dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };

                    try {
                        const startDate = new Date(parts[0]);
                        const endDate = new Date(parts[1]);

                        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                            return isoDateRange;
                        }

                        const formattedStart = startDate.toLocaleDateString(userLocale, dateOptions);
                        const formattedEnd = endDate.toLocaleDateString(userLocale, dateOptions);

                        return `${formattedStart} - ${formattedEnd}`;
                    } catch (e) {
                        return isoDateRange;
                    }
                };

                // Support de la nouvelle structure par sections
                $('.c-sheet__section .c-sheet__item-content').find('.c-form-input, date-range-picker, combo-box').each(function () {
                    const input = $(this);
                    const tagName = this.tagName.toLowerCase();
                    let val;
                    const isDateRangePicker = tagName === 'date-range-picker';
                    const isCombobox = tagName === 'combo-box';

                    // Gérer le web component date-range-picker
                    if (isDateRangePicker) {
                        val = this.value;
                    } else if (isCombobox) {
                        // Récupérer les valeurs sélectionnées du combobox
                        // Fallback sur l'attribut si le web component n'est pas encore initialisé
                        if (typeof this.value !== 'undefined' && Array.isArray(this.value)) {
                            val = this.value;
                        } else {
                            try {
                                val = JSON.parse(input.attr('selected-values') || '[]');
                            } catch (e) {
                                val = [];
                            }
                        }
                    } else {
                        val = input.val();
                    }

                    // Vérifier si une valeur est présente
                    const hasValue = isCombobox
                        ? (Array.isArray(val) && val.length > 0)
                        : (val && val !== '' && val !== 'all' && val !== '-1');

                    if (hasValue) {
                        // Récupérer le label du champ
                        const label = input.closest('li').find('.c-form-label').text().trim();
                        if (label) {
                            // Gérer les sélections multiples
                            let displayValues = [];
                            if (isCombobox && typeof this.selectedLabels !== 'undefined' && Array.isArray(this.selectedLabels)) {
                                displayValues = this.selectedLabels;
                            } else if (input.is('select') && input.prop('multiple')) {
                                input.find('option:selected').each(function() {
                                    displayValues.push($(this).text().trim());
                                });
                            } else if (input.is('select')) {
                                displayValues.push(input.find('option:selected').text().trim());
                            } else if (isDateRangePicker) {
                                // Formater la plage de dates
                                displayValues.push(formatDateRange(val));
                            } else {
                                displayValues.push(val);
                            }

                            // Afficher le label suivi des badges des valeurs
                            if (displayValues.length > 0) {
                                let filterHtml = `<span class="c-table__filter-item"><span class="c-table__filter-label">${label}:</span>`;
                                displayValues.forEach(function(displayVal) {
                                    if (displayVal && displayVal !== '') {
                                        filterHtml += `<span class="c-tag c-tag--small c-tag--default ml-1">${displayVal}</span>`;
                                    }
                                });
                                filterHtml += '</span>';
                                toggleFilterResultContainer.append(filterHtml);
                            }
                        }
                    }
                });

                // Support de l'ancienne structure (fallback) - exclut les sections
                $('.c-sheet__item-content').not('.c-sheet__section .c-sheet__item-content').find('.c-form-input:first:not(:checkbox), .select2, :checkbox:checked:first').each(function () {
                    const getPrevFilterItemContent = $(this).closest($('.c-sheet__item-content')).prev('.c-sheet__item').html();
                    if ($(this).val() && $(this).val() !== 'all'  && $(this).val() !== '-1') {
                        toggleFilterResultContainer.append(getPrevFilterItemContent);
                    }
                });

                // Toggle result container
                if ($.trim(toggleFilterResultContainer.html()) !== '') {
                    toggleFilterResultContainer.css('display', 'flex');
                    resetFilter.css('display', 'block');
                    exportFilter.css('display', 'block');
                    toggleFilter.text('Modifier les filtres');
                }
            });

            // Clear search bar
            if(searchBar.val() !== '') {
                clearSearchBar.css('display', 'block');
                clearSearchBar.on('click', function () {
                    searchBar.val('');
                })
            }

            selectResultPerPage.on('change', this.switchResultPerPage);
        },

        toggleFilterItem(e) {
            e.preventDefault();
            $(this).next('.c-sheet__item-content').toggle();
            $(this).toggleClass('c-sheet__item--active');
        },

        showFilterItemTag() {
            // Ne pas ajouter de tags aux titres de sections
            const itemContent = $(this).closest('.c-sheet__item-content');
            if (itemContent.closest('.c-sheet__section').length > 0) {
                return; // C'est une section, on ignore
            }

            const getTextInputs = [];
            const timePicker = itemContent.find('.timepicker');
            const datePicker = itemContent.find('.input-calendar-with-past');
            const isTimePicker = $(this).is('.timepicker');
            const isDatePicker = $(this).is('.input-calendar-with-past');

            $(this).find('option:selected').each(function () {
                getTextInputs.push($(this).text());
            });

            if(timePicker.length > 0) {
                if(isTimePicker || isDatePicker) {
                    if(timePicker.val().length > 0 && datePicker.val().length > 0) {
                        getTextInputs.push(datePicker.val(), timePicker.val());
                    }
                    else if(timePicker.val().length > 0 && datePicker.val().length <= 0) {
                        getTextInputs.push(timePicker.val());
                    }
                    else if(timePicker.val().length <= 0 && datePicker.val().length > 0) {
                        getTextInputs.push(datePicker.val());
                    }
                }
            }
            else if($(this).is(':checkbox')) {
                itemContent.find(':checkbox:checked').each(function () {
                    getTextInputs.push($(this).next('.c-form-label').text());
                })
            }
            else if(getTextInputs.length <= 0) {
                getTextInputs.push($(this).val());
            }


            const getPrevFilterItem = itemContent.prev('.c-sheet__item');
            getPrevFilterItem.find('.c-tag').remove();
            getTextInputs.forEach((textInput) => {
                if ($(this).val() && $(this).val() !== 'all' && $(this).val() !== '-1') {
                    getPrevFilterItem.append(`<div class='u-tips u-tips--bottom' aria-label='${textInput}'><span class='c-tag c-tag--small c-tag--default u-tips u-tips--bottom mr-1'>${textInput}</span></div>`);
                }
            });
        },

        clearFilterItemTag(e) {
            e.preventDefault();
            const getPrevFilterItemContent = $(this).closest($('.c-sheet__item-content'));
            getPrevFilterItemContent.find('.c-form-input').select2('val', '');
            getPrevFilterItemContent.find('.c-form-input').val('');
            getPrevFilterItemContent.prev('.c-sheet__item').find('.c-tag').remove();
        },

        switchResultPerPage() {
            $('.js-nb-per-page-select-hidden').val($('.js-nb-per-page-select option:selected').val());
            $('.js-filter-form').submit();
        },

        toggleSection(e) {
            e.preventDefault();
            e.stopPropagation();
            const toggle = $(this);
            const section = toggle.closest('.c-sheet__section');
            const content = section.find('.c-sheet__item-content');

            const isOpen = content.is(':visible');

            // Fermer toutes les autres sections
            if (!isOpen) {
                $('.c-sheet__section').each(function() {
                    const otherSection = $(this);
                    if (!otherSection.is(section)) {
                        const otherContent = otherSection.find('.c-sheet__item-content');
                        if (otherContent.is(':visible')) {
                            otherContent.slideUp(200);
                            otherSection.find('.c-sheet__item').removeClass('c-sheet__item--active');
                        }
                    }
                });
            }

            content.slideToggle(200);
            toggle.toggleClass('c-sheet__item--active');
        },

        updateSectionCounts() {
            $('.js-filter-section').each(function() {
                const section = $(this);
                const badge = section.find('.js-filter-count');
                let count = 0;

                // Compter les inputs classiques
                section.find('.c-form-input').each(function() {
                    const input = $(this);
                    const val = input.val();

                    if (val && val !== '' && val !== 'all' && val !== '-1') {
                        // Pour les tableaux (select multiple), vérifier que le tableau n'est pas vide
                        if (Array.isArray(val)) {
                            if (val.length > 0) {
                                count += val.length;
                            }
                        } else {
                            count++;
                        }
                    }
                });

                // Compter le web component date-range-picker
                section.find('date-range-picker').each(function() {
                    const val = this.value;
                    if (val && val !== '') {
                        count++;
                    }
                });

                // Compter le web component combo-box
                section.find('combo-box').each(function() {
                    let val;
                    if (typeof this.value !== 'undefined' && Array.isArray(this.value)) {
                        val = this.value;
                    } else {
                        try {
                            val = JSON.parse($(this).attr('selected-values') || '[]');
                        } catch (e) {
                            val = [];
                        }
                    }
                    if (Array.isArray(val) && val.length > 0) {
                        count += val.length;
                    }
                });

                if (count > 0) {
                    badge.text(count).show();
                } else {
                    badge.hide();
                }
            });
        },

        initDateRangePicker() {
            const $picker = $('.date-range-picker');
            if (!$picker.length) return;

            const eventBegin = $picker.data('event-begin');
            const eventEnd = $picker.data('event-end');
            const eventPublished = $picker.data('event-published');

            const ranges = {
                "Aujourd'hui": [moment(), moment()],
                'Hier': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                '7 derniers jours': [moment().subtract(6, 'days'), moment()],
                '30 derniers jours': [moment().subtract(29, 'days'), moment()],
            };

            // Options dynamiques basées sur l'événement
            if (eventPublished && eventEnd) {
                ranges["De la publication à la fin de l'événement"] = [
                    moment(eventPublished),
                    moment(eventEnd)
                ];
            }
            if (eventBegin && eventEnd) {
                ranges["Pendant toute la durée de l'événement"] = [
                    moment(eventBegin),
                    moment(eventEnd)
                ];
            }

            $picker.daterangepicker({
                ranges,
                locale: {
                    format: 'DD/MM/YYYY',
                    applyLabel: 'Appliquer',
                    cancelLabel: 'Effacer',
                    customRangeLabel: 'Personnalisé',
                    daysOfWeek: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
                    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                    firstDay: 1,
                },
                autoUpdateInput: false,
                opens: 'left',
                showDropdowns: true,
                alwaysShowCalendars: true,
            }, function(start, end) {
                $picker.val(`${start.format('DD/MM/YYYY')} - ${end.format('DD/MM/YYYY')}`);
                $('.date-range-begin').val(start.format('DD/MM/YYYY'));
                $('.date-range-end').val(end.format('DD/MM/YYYY'));
                $picker.trigger('change');
            });

            // Gestion du bouton Effacer
            $picker.on('cancel.daterangepicker', function() {
                $(this).val('');
                $('.date-range-begin').val('');
                $('.date-range-end').val('');
                $(this).trigger('change');
            });
        },
    };
};

window.addEventListener('load', () => {
    if ($('.c-sheet').length > 0) {
        window.YP.FilterTable().init();
    }
});
